import React, { useState } from 'react';
import { PropTypes } from 'prop-types';

import Button from './Button';

import { BorderRadius, FontSizes } from '../Theme';

const AccordionCard = ({ button, checkbox, children, label }) => {
  const styles = {
    card: {
      backgroundColor: '#fff',
      border: '1px solid #e5e5e5',
      borderBottom: '1px solid #e5e5e5',
      borderRadius: BorderRadius.DEFAULT,
      boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.1)',
      marginBottom: '20px',
      padding: '20px',
      cursor: 'pointer'
    },
    face: {
      display: 'flex',
      alignItems: 'center'
    },
    title: {
      fontSize: FontSizes.LARGE,
      marginRight: '30px'
    },
    button: {
      marginLeft: 'auto'
    },
    content: {
      backgroundColor: '#f5f5f5',
      margin: '20px -20px -20px',
      padding: '20px',
      borderRadius: `0 0 ${BorderRadius.DEFAULT}px ${BorderRadius.DEFAULT}px`,
      borderTop: '1px solid #e5e5e5'
    }
  };

  const [open, setOpen] = useState(false);

  const preventClose = e => {
    e.stopPropagation();
  };

  return (
    <div onClick={setOpen.bind(null, !open)} style={styles.card}>
      <div style={styles.face}>
        {checkbox ? <div onClick={preventClose}>{checkbox}</div> : null}
        <div style={styles.title}>{label}</div>
        <div onClick={preventClose}>
          {button ? <Button {...button} style={styles.button} /> : null}
        </div>
      </div>

      {open ? (
        <div onClick={preventClose} style={styles.content}>
          {children}
        </div>
      ) : null}
    </div>
  );
};

AccordionCard.propTypes = {
  button: PropTypes.object,
  checkbox: PropTypes.node,
  children: PropTypes.node,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default AccordionCard;
